import { render, staticRenderFns } from "./chat.vue?vue&type=template&id=f3e50f06&scoped=true"
import script from "./chat.vue?vue&type=script&lang=js"
export * from "./chat.vue?vue&type=script&lang=js"
import style0 from "./chat.vue?vue&type=style&index=0&id=f3e50f06&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3e50f06",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/examreg-client-prod-tc/exam-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f3e50f06')) {
      api.createRecord('f3e50f06', component.options)
    } else {
      api.reload('f3e50f06', component.options)
    }
    module.hot.accept("./chat.vue?vue&type=template&id=f3e50f06&scoped=true", function () {
      api.rerender('f3e50f06', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/consult/views/chat.vue"
export default component.exports